import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpService } from '@services/http.service';
import { WidgetSensorCategory } from '@models/widget/widget.model';

@Injectable({
  providedIn: 'root',
})
export class SensorCatalogService extends HttpService {
  private readonly sensorsUrl = `${environment.apiUrl}/devices/sensors`;
  private catalog$: Observable<WidgetSensorCategory[]> | null = null;

  getCatalog(): Observable<WidgetSensorCategory[]> {
    if (!this.catalog$) {
      this.catalog$ = this.get(`${this.sensorsUrl}/catalog`, this.createHeaders()).pipe(
        shareReplay(1),
      );
    }
    return this.catalog$;
  }
}
